import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IAnalyticsFunnelUsers,
  IAnalyticsFunnelUsersQuery,
  IAnalyticsOrderPlaces,
  IAnalyticsOrderPlacesQuery,
  IAnalyticsOverview,
  IAnalyticsOverviewQuery,
  IAnalyticsPeriod,
  IAnalyticsSourceVisits
} from 'models/analytics'

export const analyticsApi = {
  getOverview(query: IAnalyticsOverviewQuery): Promise<AxiosResponse<IAnalyticsOverview>> {
    return privateApi.get<IAnalyticsOverview>('admin/analytics/overview', {
      params: query
    })
  },
  getSourceVisits(period: IAnalyticsPeriod): Promise<AxiosResponse<IAnalyticsSourceVisits>> {
    return privateApi.get<IAnalyticsSourceVisits>('admin/analytics/source-visits', {
      params: period
    })
  },
  getOrderPlaces(
    query: IAnalyticsOrderPlacesQuery
  ): Promise<AxiosResponse<IAnalyticsOrderPlaces>> {
    return privateApi.get<IAnalyticsOrderPlaces>('admin/analytics/order-places', {
      params: query
    })
  },
  getFunnelUsers(
    query: IAnalyticsFunnelUsersQuery
  ): Promise<AxiosResponse<IAnalyticsFunnelUsers>> {
    return privateApi.get<IAnalyticsFunnelUsers>('admin/analytics/funnel-users', {
      params: query
    })
  },
  exportFunnelUsers(query: IAnalyticsFunnelUsersQuery): Promise<AxiosResponse<Blob>> {
    return privateApi.get<Blob>('admin/analytics/funnel-users/export', {
      params: query,
      responseType: 'blob'
    })
  }
}
